import React, { useEffect, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { CustomCheckbox, CustomDataTableHeader, CustomModal } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import { SplitButton } from 'primereact/splitbutton'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import ModalGerarPickingAutomatico from './ModalGerarPickingAutomatico'

function ModalGerarPickingElement({ frota, onClose, selectedTp, dispatch }) {
  const [modalEntregas, setModalEntregas] = useState(frota ? frota.deliveries : [])
  const [globalFilter, setGlobalFilter] = useState('')
  const [allSelected, setAllSelected] = useState(false)
  const [modalAutomaticoHandler, setModalAutomaticoHandler] = useState({
    isVisible: false,
    tipo: null, // 'PorCliente' | 'PorClienteEstoque' | 'Reconferencia'
  })

  useEffect(() => {
    setModalEntregas(frota ? frota.deliveries : [])
  }, [frota])

  //Events
  const onCheckBoxRowClicked = (entrega, checked) => {
    const index = modalEntregas.findIndex(e => e.step_id === entrega.step_id)
    if (index !== -1) {
      modalEntregas[index].selected = checked
      setModalEntregas([...modalEntregas])
    }
  }

  const onSelectAllCheck = value => {
    setModalEntregas(modalEntregas.map(e => ({ ...e, selected: value })))
    setAllSelected(value)
  }

  // Valida a seleção de entregas e abre o modal de geração automática de picking
  const abrirModalPickingAutomatico = tipo => {
    const entregasSelecionadas = modalEntregas.filter(me => me.selected)
    if (entregasSelecionadas.length === 0) {
      dispatch(showMessageBox(null, 'Selecione pelo menos 1 entrega'))
      return
    }
    setModalAutomaticoHandler({ isVisible: true, tipo })
  }

  const onGerarPicking = () => abrirModalPickingAutomatico('PorCliente')

  const onGerarPickingClienteEstoque = () => abrirModalPickingAutomatico('PorClienteEstoque')

  const onGerarPickingReconferenciaClick = () => abrirModalPickingAutomatico('Reconferencia')

  const onSalvarPickingAutomatico = async ({
    area_association_model,
    pickingteam_id,
    preparar_para_download,
    descricoes,
  }) => {
    try {
      const { tipo } = modalAutomaticoHandler
      setModalAutomaticoHandler({ isVisible: false, tipo: null })

      const picking_name = descricoes && descricoes.length ? descricoes[0].name : undefined
      const entregasSelecionadas = modalEntregas.filter(me => me.selected)
      const associacoes = entregasSelecionadas.map(es => ({
        associacao_id: es.associacao_id,
        step_id: es.step_id,
      }))

      if (tipo === 'Reconferencia') {
        dispatch(showLoadingBox('Gerando Picking de Reconferência...'))
        const usuario = getUsuarioInfo()

        await PickingHttp.gerarPickingReconferenciaAhPartirRoteirizacao({
          fleet_id: frota.fleet_id,
          user_id: usuario.id,
          area_association_model,
          pickingteam_id,
          preparar_para_download,
          picking_name,
          associacoes,
        })
        dispatch(showMessageBox('Picking de Reconferência gerado com sucesso', null))
      } else {
        const payload = {
          info: [{ fleet_id: frota.fleet_id, picking_name, associacoes }],
          area_association_model,
          pickingteam_id,
          preparar_para_download,
        }

        if (tipo === 'PorClienteEstoque') {
          dispatch(showLoadingBox('Gerando o(s) Picking(s) (Cliente-Estoque)'))
          await PickingHttp.gerarPickingAhPartirRoteirizacaoClienteEstoque(payload)
          dispatch(showMessageBox('Pickings Cliente-Estoque gerados com sucesso', null))
        } else {
          dispatch(showLoadingBox('Gerando o(s) Picking(s)'))
          await PickingHttp.gerarPickingAhPartirRoteirizacao(payload)
          dispatch(showMessageBox('Pickings gerados com sucesso', null))
        }
      }

      onClose(null)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const getModalAutomaticoHeader = () => {
    const { tipo } = modalAutomaticoHandler
    if (tipo === 'PorClienteEstoque') return 'Gerar Picking - Por Cliente-Estoque'
    if (tipo === 'Reconferencia') return 'Gerar Picking - Reconferência'
    return 'Gerar Picking - Por Cliente'
  }

  const splitItems = [
    {
      label: 'Gerar Picking - Por Cliente-Estoque',
      command: onGerarPickingClienteEstoque,
    },
    {
      label: 'Gerar Picking - Reconferência',
      command: onGerarPickingReconferenciaClick,
    },
  ]

  return (
    <>
    <CustomModal
      width="80%"
      maximizable={true}
      header={
        <span>
          Gerar Picking - <strong>{frota ? frota.vehicle_badge : ''}</strong>
        </span>
      }
      isVisible={!!frota}
      onClose={() => onClose(null)}
    >
      <div className="p-grid">
        <div style={{ paddingLeft: 20, paddingTop: 12 }}>
          <CustomCheckbox checked={allSelected} onChange={value => onSelectAllCheck(value)}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div style={{ paddingLeft: 8 }}>
          <SplitButton
            className="bck-primary"
            label="Gerar Picking - Por Cliente"
            menuStyle={{ width: 260 }}
            onClick={onGerarPicking}
            model={splitItems}
          />
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <DataTable
          value={modalEntregas}
          rows={5}
          paginator={true}
          header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          globalFilter={globalFilter}
          className="auto-layout"
        >
          <Column
            style={tableCellCentered(60)}
            body={entrega => (
              <CustomCheckbox
                checked={entrega.selected}
                onChange={checked => onCheckBoxRowClicked(entrega, checked)}
              />
            )}
          />
          <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
          <Column field="company_name" header="Empresa" style={tableCellCentered(120)} />
          <Column field="razao_social" header="Razão Social" />
          <Column field="city" header="Cidade" />
          <Column field="district" header="Bairro" />
          <Column field="qte_sku" header="Qte. SKUs" style={tableCellCentered(80)} />
          <Column field="weight" header="Peso" style={tableCellCentered(80)} />
        </DataTable>
      </div>
    </CustomModal>
    <ModalGerarPickingAutomatico
      header={getModalAutomaticoHeader()}
      estilo={modalAutomaticoHandler.tipo === 'Reconferencia' ? 'Reconferencia' : 'Expedicao'}
      fleetIds={frota ? [frota.fleet_id] : []}
      tpId={selectedTp}
      isVisible={modalAutomaticoHandler.isVisible}
      onClose={() => setModalAutomaticoHandler({ isVisible: false, tipo: null })}
      onSave={onSalvarPickingAutomatico}
    />
  </>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalGerarPickingElement)
